import { useState } from 'react';
import { KhachHang, TaiKhoan } from '@/types/schemas';

export interface UseSearchFieldStatesReturn {
  // Account (BasicInfo)
  account: TaiKhoan | null;
  setAccount: (account: TaiKhoan | null) => void;

  // Customer (DetailsTab)
  customer: KhachHang | null;
  setCustomer: (customer: KhachHang | null) => void;

  // Customer Groups (DetailsTab)
  customerGroup1: BanHangRecord | null;
  setCustomerGroup1: (group: BanHangRecord | null) => void;
  customerGroup2: BanHangRecord | null;
  setCustomerGroup2: (group: BanHangRecord | null) => void;
  customerGroup3: BanHangRecord | null;
  setCustomerGroup3: (group: BanHangRecord | null) => void;

  // Region (DetailsTab)
  region: BanHangRecord | null;
  setRegion: (region: BanHangRecord | null) => void;
}

export function useSearchFieldStates(): UseSearchFieldStatesReturn {
  const [account, setAccount] = useState<TaiKhoan | null>(null);
  const [customer, setCustomer] = useState<KhachHang | null>(null);

  // Add new states
  const [customerGroup1, setCustomerGroup1] = useState<BanHangRecord | null>(null);
  const [customerGroup2, setCustomerGroup2] = useState<BanHangRecord | null>(null);
  const [customerGroup3, setCustomerGroup3] = useState<BanHangRecord | null>(null);
  const [region, setRegion] = useState<BanHangRecord | null>(null);

  return {
    account,
    setAccount,
    customer,
    setCustomer,
    customerGroup1,
    setCustomerGroup1,
    customerGroup2,
    setCustomerGroup2,
    customerGroup3,
    setCustomerGroup3,
    region,
    setRegion
  };
}
